var I = (n, o, e) => new Promise((g, c) => {
  var d = (t) => {
    try {
      m(e.next(t));
    } catch (s) {
      c(s);
    }
  }, p = (t) => {
    try {
      m(e.throw(t));
    } catch (s) {
      c(s);
    }
  }, m = (t) => t.done ? g(t.value) : Promise.resolve(t.value).then(d, p);
  m((e = e.apply(n, o)).next());
});
import { r as L, u as k, a as v, o as J, b as B, B as C, c as _, e as N, g as u, h as y, w as b, t as h, k as V, i as T } from "./define-element-XpjsV6s1.js";
import { a as w, i as S } from "./utils-CMsllPx8.js";
import { u as R } from "./use-user-CwEHAZOt.js";
import { I as x } from "./Input-yplyeePD.js";
import { B as U } from "./Button-D5lKR5Sd.js";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function D() {
  function n(o, e) {
    return I(this, null, function* () {
      return yield L(`join_list/${o}`, {
        method: "POST",
        body: JSON.stringify(e)
      });
    });
  }
  return {
    addSubscriber: n
  };
}
const O = {
  ref: "container",
  class: "offset-join-list"
}, $ = {
  ref: "hiddenInputs",
  style: { display: "none" }
}, F = ["name", "value"], M = ["name", "value"], z = ["name", "value"], A = { class: "grouped" }, P = {
  key: 0,
  class: "error"
}, Y = {
  key: 0,
  class: "error"
}, G = { class: "grouped" }, H = {
  key: 0,
  class: "error"
}, K = {
  __name: "JoinList",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    listId: {
      type: String,
      default: "",
      required: !0
    },
    label: {
      type: String,
      default: "Next"
    },
    firstNameName: {
      type: String,
      default: "data[first_name]"
    },
    lastNameName: {
      type: String,
      default: "data[last_name]"
    },
    emailName: {
      type: String,
      default: "data[email]"
    }
  },
  emits: {
    submit: { bubble: !0 }
  },
  setup(n, { emit: o }) {
    const e = n, g = o, { addSubscriber: c } = D(), { prefilledData: d } = R(), p = k("container"), m = k("hiddenInputs"), t = v(d.value.first_name), s = v(d.value.last_name), i = v(d.value.email), a = v({
      firstName: null,
      lastName: null,
      email: null
    });
    function q() {
      a.value = {
        firstName: null,
        lastName: null,
        email: null
      };
      let l = !0;
      return S(t.value) && (a.value.firstName = "First name is required", l = !1), S(s.value) && (a.value.lastName = "Last name is required", l = !1), S(i.value) && (a.value.email = "Email is required", l = !1), /\S+@\S+\.\S+/.test(i.value) || (a.value.email = "Email is invalid", l = !1), l;
    }
    function E() {
      return I(this, null, function* () {
        if (S(e.listId)) {
          console.error("JoinList: listId prop is required");
          return;
        }
        if (q())
          try {
            const l = yield c(e.listId, {
              EmailAddress: i.value,
              Name: `${t.value} ${s.value}`,
              Resubscribe: !0,
              ConsentToTrack: "Yes"
            });
            g("submit");
          } catch (l) {
            console.error("JoinList: Error adding subscriber", l);
          }
      });
    }
    return J(() => {
      B(p.value, e.inheritStyle);
      const l = w(
        p.value,
        "offset-join-list-hidden-inputs"
      );
      C(() => {
        l.appendChild(m.value);
      });
    }), (l, r) => (_(), N("div", O, [
      u("div", $, [
        u("input", {
          type: "hidden",
          name: e.firstNameName,
          value: t.value
        }, null, 8, F),
        u("input", {
          type: "hidden",
          name: e.lastNameName,
          value: s.value
        }, null, 8, M),
        u("input", {
          type: "hidden",
          name: e.emailName,
          value: i.value
        }, null, 8, z)
      ], 512),
      u("div", A, [
        y(x, {
          type: "text",
          label: "First Name",
          modelValue: t.value,
          "onUpdate:modelValue": r[0] || (r[0] = (f) => t.value = f),
          floating: !0,
          required: !0
        }, {
          default: b(() => [
            a.value.firstName ? (_(), N("div", P, h(a.value.firstName), 1)) : V("", !0)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        y(x, {
          type: "text",
          label: "Last Name",
          modelValue: s.value,
          "onUpdate:modelValue": r[1] || (r[1] = (f) => s.value = f),
          floating: !0,
          required: !0
        }, {
          default: b(() => [
            a.value.lastName ? (_(), N("div", Y, h(a.value.lastName), 1)) : V("", !0)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      u("div", G, [
        y(x, {
          type: "text",
          label: "Email",
          modelValue: i.value,
          "onUpdate:modelValue": r[2] || (r[2] = (f) => i.value = f),
          floating: !0,
          required: !0,
          autocorrect: "off",
          autocapitalize: "off"
        }, {
          default: b(() => [
            a.value.email ? (_(), N("div", H, h(a.value.email), 1)) : V("", !0)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      y(U, { onClick: E }, {
        default: b(() => [
          T(h(e.label), 1)
        ]),
        _: 1
      })
    ], 512));
  }
}, le = /* @__PURE__ */ j(K, [["__scopeId", "data-v-5cd83141"]]);
export {
  le as J
};
